import createBlockButton from './createBlockButton.js';
import createBlockAlignmentButton from './createBlockAlignmentButton.js';
import createBlockAlignmentAndSizeButton from './createBlockAlignmentAndSizeButton.js';
import createBlockSizeButton from './createBlockSizeButton.js';
import createSliderPanelButton from './createSliderPanelButton.js';
import { BUTTONS } from './keys.js';
export { default as BlockLinkButton } from './BlockLinkButton.js';
export { default as BlockSpoilerButton } from './BlockSpoilerButton.js';
import { AlignLeftIcon, AlignTextCenterIcon, AlignRightIcon } from 'wix-rich-content-editor-common';
import SizeSmallIcon from '../../Icons/SizeSmallIcon.js';
import SizeMediumIcon from '../../Icons/SizeMediumIcon.js';
import SizeLargeIcon from '../../Icons/SizeLargeIcon.js';
import SizeOriginalIcon from '../../Icons/SizeOriginalIcon.js';
import AlignCenterIcon from '../../Icons/AlignCenterIcon.js';
import SizeSmallCenterIcon from '../../Icons/SizeSmallCenterIcon.js';
import SizeSmallLeftIcon from '../../Icons/SizeSmallLeftIcon.js';
import SizeSmallRightIcon from '../../Icons/SizeSmallRightIcon.js';
import SizeBestFitIcon from '../../Icons/SizeBestFitIcon.js';
import SizeFullWidthIcon from '../../Icons/SizeFullWidthIcon.js';
import TrashIcon from '../../Icons/TrashIcon.js';
import WidthIcon from '../../Icons/WidthIcon.js';
import HeightIcon from '../../Icons/HeightIcon.js';
import 'react';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-ui-components';
import '../baseToolbarButton.js';
import 'react-dom';
import 'wix-rich-content-common';
import 'lodash';
import '../../Icons/SpoilerButtonIcon.js';

const sizeSmallButton = (icon) => createBlockSizeButton({
  size: "small",
  Icon: icon || SizeSmallIcon,
  tooltipTextKey: "DividerPlugin_Width_Small_Tooltip"
});
const sizeMediumButton = (icon) => createBlockSizeButton({
  size: "medium",
  Icon: icon || SizeMediumIcon,
  tooltipTextKey: "DividerPlugin_Width_Medium_Tooltip"
});
const sizeLargeButton = (icon) => createBlockSizeButton({
  size: "large",
  Icon: icon || SizeLargeIcon,
  tooltipTextKey: "DividerPlugin_Width_Large_Tooltip"
});
const alignmentLeftButton = (icon) => createBlockAlignmentButton({
  alignment: "left",
  Icon: icon || AlignLeftIcon,
  tooltipTextKey: "AlignTextLeftButton_Tooltip"
});
const alignmentCenterButton = (icon) => createBlockAlignmentButton({
  alignment: "center",
  Icon: icon || AlignTextCenterIcon,
  tooltipTextKey: "AlignTextCenterButton_Tooltip"
});
const alignmentRightButton = (icon) => createBlockAlignmentButton({
  alignment: "right",
  Icon: icon || AlignRightIcon,
  tooltipTextKey: "AlignTextRightButton_Tooltip"
});
const sizeOriginalButton = (icon) => createBlockAlignmentAndSizeButton({
  size: "original",
  alignment: "left",
  Icon: icon || SizeOriginalIcon,
  tooltipTextKey: "SizeOriginalButton_Tooltip"
});
const sizeContentCenterButton = (icon) => createBlockAlignmentAndSizeButton({
  size: "content",
  alignment: "center",
  Icon: icon || AlignCenterIcon,
  tooltipTextKey: "AlignObject_Center_Tooltip"
});
const sizeSmallCenterButton = (icon) => createBlockAlignmentAndSizeButton({
  size: "small",
  alignment: "center",
  Icon: icon || SizeSmallCenterIcon,
  tooltipTextKey: "SizeSmallCenterButton_Tooltip"
});
const sizeSmallLeftButton = (icon) => createBlockAlignmentAndSizeButton({
  alignment: "left",
  size: "small",
  Icon: icon || SizeSmallLeftIcon,
  tooltipTextKey: "AlignObject_Left_Tooltip"
});
const sizeSmallRightButton = (icon) => createBlockAlignmentAndSizeButton({
  size: "small",
  alignment: "right",
  Icon: icon || SizeSmallRightIcon,
  tooltipTextKey: "AlignObject_Right_Tooltip"
});
const alignLeftButton = (icon) => createBlockAlignmentButton({
  alignment: "left",
  Icon: icon || SizeSmallLeftIcon,
  tooltipTextKey: "SizeSmallLeftButton_Tooltip"
});
const alignCenterButton = (icon) => createBlockAlignmentButton({
  alignment: "center",
  Icon: icon || AlignCenterIcon,
  tooltipTextKey: "AlignCenterButton_Tooltip"
});
const alignRightButton = (icon) => createBlockAlignmentButton({
  alignment: "right",
  Icon: icon || SizeSmallRightIcon,
  tooltipTextKey: "SizeSmallRightButton_Tooltip"
});
const sizeContentButton = (icon) => createBlockAlignmentAndSizeButton({
  size: "content",
  alignment: "center",
  Icon: icon || SizeBestFitIcon,
  tooltipTextKey: "SizeContentButton_Tooltip"
});
const sizeFullWidthButton = (icon) => createBlockAlignmentAndSizeButton({
  size: "fullWidth",
  alignment: "center",
  Icon: icon || SizeFullWidthIcon,
  tooltipTextKey: "SizeFullWidthButton_Tooltip"
});
const deleteButton = (icon) => createBlockButton({
  name: "Delete",
  Icon: icon || TrashIcon,
  tooltipTextKey: "DeleteButton_Tooltip"
});
const widthButton = (icon) => createSliderPanelButton({
  Icon: icon || WidthIcon,
  tooltipTextKey: "ChangeDimensions_Width_Tooltip",
  getValue: ({ componentData }) => componentData.config.width,
  onChange: ({ getEditorBounds, store }) => (width) => {
    var _a;
    const bounds = getEditorBounds();
    const editorWidth = bounds ? bounds.width : 740;
    if (width >= editorWidth && ((_a = store.get("componentData")) == null ? void 0 : _a.config.alignment)) {
      store.update("componentData", { config: { alignment: "center" } });
    }
    store.update("componentData", { config: { width } });
  }
});
const heightButton = (icon) => createSliderPanelButton({
  Icon: icon || HeightIcon,
  tooltipTextKey: "ChangeDimensions_Height_Tooltip",
  getValue: ({ componentData }) => componentData.config.height,
  onChange: ({ store }) => (height) => store.update("componentData", { config: { height } })
});
const BUTTONS_BY_KEY = {
  [BUTTONS.SIZE_SMALL]: (icon) => sizeSmallButton(icon),
  [BUTTONS.SIZE_MEDIUM]: (icon) => sizeMediumButton(icon),
  [BUTTONS.SIZE_LARGE]: (icon) => sizeLargeButton(icon),
  [BUTTONS.SIZE_ORIGINAL]: (icon) => sizeOriginalButton(icon),
  [BUTTONS.SIZE_CONTENT_CENTER]: (icon) => sizeContentCenterButton(icon),
  [BUTTONS.SIZE_CONTENT]: (icon) => sizeContentButton(icon),
  [BUTTONS.SIZE_FULL_WIDTH]: (icon) => sizeFullWidthButton(icon),
  [BUTTONS.ALIGN_LEFT]: (icon) => alignLeftButton(icon),
  [BUTTONS.SIZE_SMALL_CENTER]: (icon) => sizeSmallCenterButton(icon),
  [BUTTONS.SIZE_SMALL_RIGHT]: (icon) => sizeSmallRightButton(icon),
  [BUTTONS.SIZE_SMALL_LEFT]: (icon) => sizeSmallLeftButton(icon),
  [BUTTONS.ALIGN_CENTER]: (icon) => alignCenterButton(icon),
  [BUTTONS.ALIGN_RIGHT]: (icon) => alignRightButton(icon),
  [BUTTONS.TEXT_ALIGN_LEFT]: (icon) => alignmentLeftButton(icon),
  [BUTTONS.TEXT_ALIGN_CENTER]: (icon) => alignmentCenterButton(icon),
  [BUTTONS.TEXT_ALIGN_RIGHT]: (icon) => alignmentRightButton(icon),
  [BUTTONS.WIDTH]: (icon) => widthButton(icon),
  [BUTTONS.HEIGHT]: (icon) => heightButton(icon)
};

export { BUTTONS, BUTTONS_BY_KEY, alignCenterButton, alignLeftButton, alignRightButton, alignmentCenterButton, alignmentLeftButton, alignmentRightButton, deleteButton, heightButton, sizeContentButton, sizeContentCenterButton, sizeFullWidthButton, sizeLargeButton, sizeMediumButton, sizeOriginalButton, sizeSmallButton, sizeSmallCenterButton, sizeSmallLeftButton, sizeSmallRightButton, widthButton };
//# sourceMappingURL=index.js.map
